// Approved public city photos. Local assets preserve full 4:3 framing.
export const destinationImages = {
    CHINA: { src: "/images/guangzhou-a-hero.webp", alt: "Skyline Guangzhou dengan Canton Tower dan jembatan", destination: "Guangzhou, China", flag: "🇨🇳" },
    THAILAND: { src: "/images/bangkok-a-hero.webp", alt: "Wat Arun, Bangkok, saat matahari terbenam", destination: "Bangkok, Thailand", flag: "🇹🇭" },
};
